module.exports = __webpack_public_path__ + "static/media/grouping.bbce0833.png";